import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { concernCategories } from "@/mocks/concerns";

const hrefMap: Record<string, string> = {
  skin: "/treatment/skin-management",
  aging: "/treatment/skin-management",
  body: "/treatment/slim-zero",
  hair: "/treatment/hair-removal",
  contour: "/treatment/injectables",
  eyes: "/treatment/eye",
};

export default function FindByConcern() {
  return (
    <section id="concern" className="bg-background-100 py-16 md:py-20 lg:py-24">
      <div className="u-container">
        <Reveal>
          <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading en="FIND BY CONCERN" jp={"あなたのお悩みを\nお聞かせください。"} />
            <p className="max-w-md text-[13px] leading-[2] text-foreground-700 md:text-sm">
              施術名が分からなくても、気になるお悩みから美容医療を探すことができます。
            </p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-12 grid grid-cols-1 gap-px border border-foreground-950/12 bg-foreground-950/12 md:mt-16 sm:grid-cols-2 lg:grid-cols-3">
            {concernCategories.map((category, index) => (
              <Link
                key={category.id}
                to={hrefMap[category.id] ?? "/treatment/skin-management"}
                className="group relative flex min-h-[240px] flex-col justify-between bg-background-50 p-7 transition-colors hover:bg-secondary-100/70 md:p-8 lg:min-h-[260px]"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-10 w-10 items-center justify-center text-foreground-600">
                    <i className={`${category.icon} text-xl`} aria-hidden />
                  </span>
                  <span className="font-label text-[11px] tracking-[0.25em] text-secondary-500">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className="mt-8">
                  <span className="en-eyebrow block text-[10px] text-foreground-500">{category.en}</span>
                  <span className="mt-3 block font-heading text-lg text-foreground-950 md:text-xl">
                    {category.jp}
                  </span>
                  <div className="mt-5 flex flex-wrap items-center gap-x-3 gap-y-2">
                    {category.items.map((item, itemIndex) => (
                      <span key={item} className="flex items-center gap-3 text-[12px] text-foreground-700">
                        {itemIndex > 0 ? <span className="h-3 w-px bg-foreground-950/20" /> : null}
                        {item}
                      </span>
                    ))}
                  </div>
                </div>

                <i
                  className="ri-arrow-right-line absolute bottom-7 right-7 text-lg text-foreground-400 transition-all group-hover:translate-x-1 group-hover:text-accent-700"
                  aria-hidden
                />
              </Link>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}